import { isEmpty } from 'lodash';

/** Простая проверка, что результат значения введенного через текстовый редактор не пустое */
export const isNotEmptyMessage = (m?: string): m is string => Boolean(m && !isEmpty(m) && m !== '<p><br></p>');
